<template>
  <div class="setup-container">
    <div class="progress-bar">
      <div class="progress-side-line progress-active"></div>
      <div class="progress-main">
        <div class="progress-icon progress-active">
          <i class="el-icon-document" />
        </div>
        <div class="progress-content">Step 01</div>
      </div>
      <div class="progress-line"></div>
      <div class="progress-main">
        <div class="progress-icon">
          <i class="el-icon-data-analysis" />
        </div>
        <div class="progress-content">Step 02</div>
      </div>
      <div class="progress-line"></div>
      <div class="progress-main">
        <div class="progress-icon">
          <i class="el-icon-bank-card" />
        </div>
        <div class="progress-content">Step 03</div>
      </div>
      <div class="progress-side-line"></div>
    </div>
    <div class="shop-form">
      <div class="row">
        <div class="field-prefix">Shop Name</div>
        <input type="text" disabled :value="shopName" />
      </div>

      <div class="row">
        <div class="field-prefix">Contact Person</div>
        <input type="text" v-model="shopForm.merchant_contact_person" />
      </div>

      <div class="row">
        <div class="field-prefix">Phone Number</div>
        <input type="text" v-model="shopForm.merchant_contact_phone" />
      </div>

      <div class="row">
        <div class="field-prefix">Shop Address</div>
        <input type="text" v-model="shopForm.merchant_address" />
      </div>

      <div class="row">
        <div class="field-prefix">Shop Logo</div>
        <div class="upload-logo-wrapper">
          <div class="upload-logo-container__setupBasicInfo">
            <el-upload
              action="https://upload-z2.qiniup.com"
              :limit="1"
              :drag="true"
              :on-success="uploadLogoSuccess"
              :on-error="uploadLogoError"
              :before-upload="beforeUploadLogo"
              :data="qiniuData"
            >
              <img
                v-if="shopForm.shop_logo_url"
                :src="displayLogoUrl"
                class="logo"
              />
              <div v-else>
                <div class="custom-icon-plus">
                  <i class="el-icon-plus" style="font-weight: 600" />
                </div>
                <div>upload logo</div>
              </div>
            </el-upload>
          </div>
        </div>
      </div>
      <div class="bottom-buttons">
        <div @click="submit">Next</div>
        <div @click="$emit('forbid')">Don't show again</div>
      </div>
    </div>
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'
export default {
  name: 'SetupBasicInfo',
  data() {
    return {
      shopName: '',
      shopForm: {
        shop_logo_url: '',
        shop_logo_qiniu_res_key: '',
        merchant_contact_person: '',
        merchant_contact_phone: '',
        merchant_address: ''
      },
      qiniuData: {
        token: ''
      }
    }
  },
  created() {
    this.shopName = this.$store.state.shop.display_shop_name
    this.fetchUploadToken()
    this.fetchShopInfo()
  },
  methods: {
    generateCustomizeString,
    fetchUploadToken() {
      request({
        url: '/upload-token',
        method: 'get'
      })
        .then((res) => {
          this.qiniuData.token = res.data['token']
        })
        .catch((error) => {
          console.log(error)
        })
    },
    uploadLogoSuccess(res, file) {
      this.shopForm.shop_logo_qiniu_res_key = res.key
      this.shopForm.shop_logo_url = 'https://img.nzmai.com.cn/' + res.key
    },
    uploadLogoError(res) {
      console.log(res)
    },
    beforeUploadLogo(file) {
      // 在图片提交前进行验证
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG && !isPNG) {
        this.$message.error(this.generateCustomizeString('jpgpngonly'))
      }
      if (!isLt2M) {
        this.$message.error(this.generateCustomizeString('lessThan2MB'))
      }

      return (isJPG || isPNG) && isLt2M
    },
    fetchShopInfo() {
      request({
        url: '/basic',
        method: 'get'
      })
        .then(response => {
          this.shopName = response.data['display_shop_name']
          this.shopForm.shop_logo_url = response.data['shop_logo_url']
          if (this.shopForm.shop_logo_url) {
            const arr = this.shopForm.shop_logo_url.split('/')
            this.shopForm.shop_logo_qiniu_res_key = arr[arr.length - 1]
          }
          this.shopForm.merchant_contact_person = response.data['merchant_contact_person']
          this.shopForm.merchant_contact_phone = response.data['merchant_contact_phone']
          this.shopForm.merchant_address = response.data['merchant_address']
        })
    },
    submit() {
      const data = {
        ...this.shopForm
      }
      request({
        url: '/basic',
        method: 'patch',
        data
      })
        .then(response => {
          if (response.status === 0) {
            this.$emit('update')
          }
        })
    }
  },
  computed: {
    displayLogoUrl() {
      return (
        this.shopForm.shop_logo_url + '?imageView2/0/w/360/h/180/q/75|imageslim'
      )
    }
  }
}
</script>

<style lang="less" scoped>
.setup-container {
  text-align: center;

  .progress-bar {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 120px;
    margin-bottom: 60px;

    .progress-active {
      background-color: #95bf47 !important;
    }
    .progress-line {
      flex-basis: 200px;
      height: 1px;
      background: rgba(0, 0, 0, 0.15);
    }
    .progress-side-line {
      flex-basis: 100px;
      height: 1px;
      background: rgba(0, 0, 0, 0.15);
    }
    .progress-main {
      position: relative;

      .progress-icon {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.15);
        i {
          font-size: 24px;
          color: #fff;
        }
      }
      .progress-content {
        position: absolute;
        width: 50px;
        height: 22px;
        bottom: -36px;
      }
    }
  }

  .shop-form {
    .row {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 16px;
      .field-prefix {
        width: 120px;
        text-align: right;
        display: inline-block;
        margin-right: 16px;
        vertical-align: middle;
        color: rgba(0, 0, 0, 0.85);
      }
      input {
        width: 240px;
        height: 32px;
        padding: 5px 12px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        color: rgba(0, 0, 0, 0.7);
        &:hover,
        &:focus {
          outline: 1px solid #95bf47;
          border: 1px solid rgba(149, 191, 71, 0.2);
        }
        &:disabled {
          border: 1px solid rgba(0, 0, 0, 0.15);
          outline: none;
          color: rgba(0, 0, 0, 0.45);
        }
      }
      .upload-logo-wrapper {
        width: 240px;
        text-align: left;
        display: inline-block;
        .upload-logo-container {
          width: 104px;
          height: 104px;
          cursor: pointer;
          background: rgba(0, 0, 0, 0.02);
          border-radius: 2px;
          border: 1px dashed rgba(0, 0, 0, 0.15);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .custom-icon-plus {
            margin-bottom: 12px;
            font-size: 16px;
          }
        }
      }
    }
    .bottom-buttons {
      margin: 0 auto;
      margin-top: 32px;
      margin-bottom: 32px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 400;
      div:first-child {
        width: 160px;
        height: 40px;
        line-height: 40px;
        background: #95bf47;
        border-radius: 20px;
        color: #fff;
        cursor: pointer;
        margin-right: 24px;
        margin-left: 90px;
      }
      div:last-child {
        height: 24px;
        line-height: 24px;
        font-size: 14px;
        text-decoration: underline;
        color: rgba(0, 0, 0, 0.65);
        line-height: 24px;
        cursor: pointer;
      }
    }
  }
  .logo {
    width: 100%;
    height: 100%;
  }
}
</style>

<style>
.upload-logo-container__setupBasicInfo .el-upload-dragger {
  width: 104px !important;
  height: 104px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
